// local server url
// const API_URL = 'http://localhost:8080/api/';

// web hosting url
const API_URL = 'https://dev.api.ansabr.tech/api/';

export default API_URL;